import { render, staticRenderFns } from "./MyModal.vue?vue&type=template&id=4fba97e2"
import script from "./MyModal.vue?vue&type=script&lang=js"
export * from "./MyModal.vue?vue&type=script&lang=js"
import style0 from "./MyModal.vue?vue&type=style&index=0&id=4fba97e2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports